var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", { staticClass: "formName" }, [
        _vm._v("姓名会自动同步到用户信息"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }